export const ADMIN_MENU = [
    {
        section: "Temporada",
        allowedRoles: [1],
        items: [
            {
                type: "group",
                label: "Sesiones",
                id: "sidebar-sesiones-admin",
                iconKey: "sesiones",
                children: [
                    {
                        label: "Asignación",
                        path: "/asignacion-sesiones",
                        routeKey: "asignacionSesiones",
                    },
                    {
                        label: "Video",
                        path: "/listado-videos",
                        routeKey: "listadoVideos",
                    },
                    {
                        label: "Evaluación",
                        path: "/listado-evaluaciones",
                        routeKey: "listadoEvaluaciones",
                    },
                    {
                        label: "Comentarios",
                        path: "/listado-comentarios",
                        routeKey: "listadoComentarios",
                    },
                ],
            },
            {
                type: "group",
                label: "Champions",
                id: "sidebar-champions-admin",
                iconKey: "champions",
                children: [
                    {
                        label: "Asignación",
                        path: "/asignacion-champions",
                        routeKey: "asignacionChampions",
                    },
                    {
                        label: "Desafíos",
                        path: "/listado-desafios",
                        routeKey: "listadoDesafios",
                    },
                ],
            },
        ],
    },

    {
        section: "Usuarios",
        allowedRoles: [1],
        items: [
            {
                type: "group",
                label: "Usuarios",
                id: "sidebar-usuarios-admin",
                iconKey: "usuarios",
                children: [
                    {
                        label: "Lista Usuarios",
                        path: "/listado-usuarios",
                        routeKey: "usuarios",
                    },
                    {
                        label: "Lista Expertos",
                        path: "/listado-expertos",
                        routeKey: "listadoExpertos",
                    },
                ],
            },
            {
                type: "group",
                label: "Distribuidores",
                id: "sidebar-distribuidores-admin",
                iconKey: "distribuidores",
                children: [
                    {
                        label: "Lista Distribuidores",
                        path: "/config-distribuidor",
                        routeKey: "distribuidores",
                    },
                ],
            },
        ],
    },

    {
        section: "Personalizable",
        allowedRoles: [1],
        items: [
            {
                type: "group",
                label: "Home",
                id: "sidebar-home-admin",
                iconKey: "home",
                children: [
                    {
                        label: "Tira de avisos",
                        path: "/listado-avisos",
                        routeKey: "listadoAvisos",
                    },
                    {
                        label: "Slider",
                        path: "/listado-slider",
                        routeKey: "listadoSlider",
                    },
                    {
                        label: "Eventos",
                        path: "/listado-eventos",
                        routeKey: "listadoEventos",
                    },
                    {
                        label: "Carrusel",
                        path: "/listado-carrusel",
                        routeKey: "listadoCarrusel",
                    },
                ],
            },
            {
                type: "group",
                label: "Más",
                id: "sidebar-mas-admin",
                iconKey: "mas",
                children: [
                    {
                        label: "Menú",
                        path: "/listado-menu",
                        routeKey: "listadoMenu",
                    },
                    {
                        label: "Pop Ups",
                        path: "/listado-pop-ups",
                        routeKey: "listadoPopUps",
                    },
                    {
                        label: "Switch Home",
                        path: "/switch-home",
                        routeKey: "switchHome",
                    },
                ],
            },
        ],
    },

    {
        section: "Panel",
        allowedRoles: [5],
        items: [
            {
                type: "link",
                label: "Usuarios",
                path: "/usuarios",
                routeKey: "usuarios",
                iconKey: "usuarios",
            },
            {
                type: "link",
                label: "Carga de usuarios",
                path: "/carga-usuarios",
                routeKey: "cargaUsuarios",
                iconKey: "cargaUsuarios",
            },
            {
                type: "link",
                label: "Acceso",
                path: "/control-acceso",
                routeKey: "accesoRol5",
                iconKey: "acceso",
            },
            {
                type: "link",
                label: "Sesiones",
                path: "/sesiones",
                routeKey: "sesionesRol5",
                iconKey: "sesiones",
            },
            {
                type: "link",
                label: "Evaluaciones especiales",
                path: "/",
                routeKey: "evaluacionesEspecialesRol5",
                iconKey: "evaluaciones",
            },
            {
                type: "link",
                label: "Champions",
                path: "/",
                routeKey: "championsRol5",
                iconKey: "champions",
            },
            {
                type: "link",
                label: "Noticias",
                path: "/noticias",
                routeKey: "noticiasRol5",
                iconKey: "noticias",
            },
        ],
    },
];